import Vue from 'vue'
import MintUI from 'mint-ui'
import axios from 'axios'
import router from '../router'
import Helper from './Helper'
import BDToast from '@/components/common/bdToast/index'
import LocalStorage from '../storage/localStorage'
import SessionStorage from '../storage/sessionStorage'
let protocol = "http://";
let host = '.bidinghuo.cn';
let AxiosIns = axios.create({
	baseURL : location.origin+'/wapi/',
	timeout : 20000,
	contentType : 'application/json',
	withCredentials : true,
});

let timer = {};
let delay = 30;
AxiosIns.interceptors.request.use((config)=>{
	//判断localstroage是否和sessionSrtoage相同，不同删除sessionStroage
	let sessionUserInfo = SessionStorage.$getSessionStorageByName('userInfo');
	let localUserInfo = LocalStorage.$getLocalStorageByName('userInfo');
	if(!!sessionUserInfo && !!localUserInfo && sessionUserInfo.id !== localUserInfo.id){
		sessionStorage.clear();
		if(!!!location.host.startsWith('sy.')){
			router.push({
				name : 'login'
			});
		}
	}

	// app用
	if(process.env.PLATFORM === 'testApp' || process.env.PLATFORM === 'app'){
		host = process.env.PLATFORM === 'app' ? host : '.bdh.com';
		if(config.domain === 'www'){
			config.baseURL = protocol + config.domain + host + '/api/';
		}else {
			let domain = localStorage.getItem('companyDomain');
			config.baseURL = protocol + domain + host + '/wapi/';
		}
	}
	if(process.env.NODE_ENV === 'development' && config.domain === 'www'){
		config.baseURL = location.origin + '/api/';
	}
	if(config.showFullLoading !== 'close'){
		if(Object.keys(timer).length < 1){
			MintUI.Indicator.open('加载中...');
		}
		timer[config.baseURL + config.url] = setTimeout(()=>{

		},delay)
	}
	return config;
});

AxiosIns.interceptors.response.use((response)=>{
	setTimeout(()=>{
		for(let key in timer){
			clearTimeout(timer[key])
			if(key === response.config.url){
				delete timer[key];
			}
		}
		if(Helper.isEmptyObj(timer)){
			MintUI.Indicator.close();
		}
	},delay)
	try{
		if (response.data.code !== 0) {
			const { notMessage } = response.config;
			if (!notMessage) {
				BDToast(response.data.message);
			}
			if(response.data.code === 200000){
				sessionStorage.removeItem("userInfo")
				localStorage.removeItem("userInfo")
				setTimeout(()=>{
					router.push({
						name : 'login'
					})
				},800)
			}
			return Promise.reject(response.data.message);
		}
	}catch(e){

	}
	return response.data;
}, (error) => {
	setTimeout(()=>{
		for(let key in timer){
			clearTimeout(timer[key])
			if(key === error.config.url){
				delete timer[key];
			}
		}
		if(Helper.isEmptyObj(timer)){
			//MintUI.Indicator.close();
		}
	},delay);
	try{
		let msg = typeof error.data === "string" ? error.data : error.data.Message;
		if(!msg || msg.length > 20){
			msg = '网络出现异常，请稍后再试'
		}
		MintUI.Toast(msg);
		MintUI.Indicator.close();
	}catch(e){
		MintUI.Indicator.close();
	}
	return Promise.reject(error);
});

export default {
	AxiosIns,
	axios
}
Vue.prototype.axios = AxiosIns;
Vue.prototype.$axios = axios;



// WEBPACK FOOTER //
// ./src/common/axiosSetting.js